export const ageTypes = [
    { option: "Under 21", label: "Under 21" },
    { option: "21-29", label: "21-29" },
    { option: "30-39", label: "30-39" },
    { option: "40-49", label: "40-49" },
    { option: "50-59", label: "50-59" },
    { option: "60-69", label: "60-69" },
    { option: "70-79", label: "70-79" },
    { option: "Over 79", label: "Over 79" },
]